import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NGXLogger } from 'ngx-logger';
import {
  EventData,
  GtmEvent,
  GtmUserDetails,
  GTM_UNKNOWN_DATA,
  UserAmilearnStatusUnknown,
  GTM_DEFAULT_COMPONENT,
} from './analytics.types';
import { AppRoute } from 'src/app/routing/routing.config';
import { gtmEventElementRoutePrefix } from './analytics';
import { TokenService } from '../auth/token.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private logger: NGXLogger,
    private gtmService: GoogleTagManagerService,
    private tokenService: TokenService
  ) {}

  addToDom(): void {
    if (!this.isGTMInitialized()) {
      this.logger.warn('[AnalyticsService] - addToDom: GTM is not inialized.');
      return;
    }

    this.logger.debug('[AnalyticsService] addToDom fired');
    this.gtmService.addGtmToDom();
  }

  pushEvent(event: GtmEvent, data: EventData): void {
    this.logger.debug(
      `[AnalyticsService] pushEvent - ${event}: ${JSON.stringify(data)}`
    );

    this.pushGtmEvent(event, data);
  }

  elementNameForRoute(route: AppRoute, element: string): string {
    return `${gtmEventElementRoutePrefix[route]} ${element}`;
  }

  private isGTMInitialized(): boolean {
    this.logger.debug('[AnalyticsService] - googleTagManagerId: ', this.gtmService.googleTagManagerId);
    return !!this.gtmService.googleTagManagerId;
  }

  private pushGtmEvent(event: GtmEvent, data: object): void {
    if (!this.isGTMInitialized()) {
      this.logger.warn('[AnalyticsService] - pushEvent: GTM is not inialized.');
      return;
    }
    const gtmTag = {
      event: event,
      component: GTM_DEFAULT_COMPONENT,
      ...data,
      ...this.gtmUserDetails(),
    };

    this.gtmService.pushTag(gtmTag);
    this.logger.debug(`[AnalyticsService] GTM event: ${JSON.stringify(gtmTag)} `);
  }

  private gtmUserDetails(): Partial<GtmUserDetails> {
    const payload = this.tokenService.idTokenPayload();

    if (payload?.amilearnStatus) {
      return {
        user_origin: payload.userOrigin,
        amilearn_user_status: payload.amilearnStatus,
        amilearn_ms_region_id: payload.country,
      };
    } else {
      return {
        user_origin: 'WWW',
        amilearn_user_status: UserAmilearnStatusUnknown.UNKNOWN,
        amilearn_ms_region_id: GTM_UNKNOWN_DATA,
      };
    }
  }
}
